import React from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Input,
  Switch,
  message,
  Tooltip,
  Icon,
  Popconfirm,
} from 'antd';
import i18n from '~settings/i18n';
import AsyncCountrySelector from '~pages/dashboard/referral/commission-plan/plan-editor/asyncCountrySelector';
import { EDIT, ADD } from '../../constant';
class ModalView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowBtn: false,
      defaultName: null,
      selectedCountryId: props.selectedPayoutPlanItem?.countryId || null,
    };
    this.loading = false;
  }

  componentDidMount() {
    const { modalType, selectedPayoutPlanItem } = this.props;
    const setFieldsValue = this.props.form?.setFieldsValue;
    if (modalType === EDIT && selectedPayoutPlanItem && setFieldsValue) {
      const {
        bookingCompletedPercent,
        bookingPaidPercent,
        countryId,
        default: default_,
        name,
      } = selectedPayoutPlanItem;
      setFieldsValue({
        bookingCompletedPercent,
        bookingPaidPercent,
        countryId,
        default: default_,
        name,
      });
    }
  }

  getDefaultPayoutPlanName = async () => {
    try {
      const defaultPayoutResponse = await this.props.queryDefault({
        default: true,
        pageNumber: 1,
        pageSize: 10,
        countryIds: [this.state.selectedCountryId],
      });

      return defaultPayoutResponse?.data?.listPartnerPayoutPlans?.edges[0]?.node;
    } catch (error) {
      message.error(error?.toString());
    }
  };

  onOk = () => {
    const {
      modalType,
      selectedPayoutPlanItem,
      form: { getFieldValue, validateFields },
    } = this.props;
    validateFields(async (err, values) => {
      try {
        this.loading = true;
        if (!err) {
          const defaultPayoutPlan = await this.getDefaultPayoutPlanName();
          if (defaultPayoutPlan) {
            if (getFieldValue?.('default') && !selectedPayoutPlanItem?.default) {
              this.setState({
                isShowBtn: true,
                defaultName: defaultPayoutPlan.name,
              });

              return;
            }
          }
          modalType === EDIT
            ? this.handUpdatePayoutPlanFn(values)
            : this.handAddPayoutPlanFn(values);
        }
      } catch (error) {
        message.error(error?.toString());
      } finally {
        this.loading = false;
      }
    });
  };

  handAddPayoutPlanFn = async values => {
    const { handAddPayoutPlan, refetchPayoutList } = this.props;
    const data = await handAddPayoutPlan({
      variables: {
        input: values,
      },
    });

    if (data?.data?.createPartnerPayoutPlan) {
      refetchPayoutList();
      this.closeFn();
    }
  };

  handUpdatePayoutPlanFn = async values => {
    const {
      selectedPayoutPlanItem: { id },
      selectedPayoutPlanItem,
      handUpdatePayoutPlan,
      refetchPayoutList,
    } = this.props;

    let values_ = { id };
    for (const item in values) {
      if (values[item] != selectedPayoutPlanItem[item]) {
        values_[`${item}`] = values[item];
      }
    }
    const data = await handUpdatePayoutPlan({
      variables: {
        input: values_,
      },
    });

    if (data?.data?.updatePartnerPayoutPlan) {
      refetchPayoutList();
      this.closeFn();
    }
  };

  confirm = () => {
    const { modalType } = this.props;
    const values = this.props.form?.getFieldsValue();
    modalType === EDIT ? this.handUpdatePayoutPlanFn(values) : this.handAddPayoutPlanFn(values);
  };

  closeFn = async () => {
    const { onClose } = this.props;
    onClose(false);
  };

  onCancel = () => {
    this.closeFn();
  };

  render() {
    const {
      form: { getFieldDecorator, setFieldsValue },
      modalType,
    } = this.props;
    const { defaultName } = this.state;
    const { isShowBtn } = this.state;
    return (
      <Modal
        key="modal-payout-plan"
        wrapClassName="payout-plan-modal-container"
        footer={[
          <Button key="back" onClick={this.onCancel}>
            {i18n.t('cms.referral.payout_plan.modal.btn.cancel')}
          </Button>,
          <Popconfirm
            key="Popconfirm-payout-plan"
            title={i18n
              .t('cms.referral.payout_plan.modal.btn.save.two.messages')
              .replace('{{name}}', defaultName)}
            onConfirm={this.confirm}
            okText="Yes"
            cancelText="No"
            onCancel={() => {
              this.setState({
                isShowBtn: false,
              });
            }}
            overlayStyle={{ width: '240px' }}
            visible={isShowBtn}
            getPopupContainer={triggerNode => triggerNode.parentElement}
          >
            <Button key="submit" loading={this.loading} type="primary" onClick={this.onOk}>
              {i18n.t('cms.referral.payout_plan.modal.btn.save')}
            </Button>
          </Popconfirm>,
        ]}
        onCancel={this.onCancel}
        visible
        width={880}
        title={
          modalType === ADD
            ? i18n.t('cms.referral.payout_plan.modal.add.title')
            : i18n.t('cms.referral.payout_plan.modal.edit.title')
        }
      >
        <Form>
          <Row gutter={40}>
            <Col span={12} key="name">
              <Form.Item label={i18n.t('cms.referral.payout_plan.modal.input.name.payout_name')}>
                {getFieldDecorator(`name`, {
                  rules: [
                    {
                      required: true,
                      message: i18n.t('cms.referral.payout_plan.modal.input.error.messages'),
                    },
                    {
                      max: 140,
                      message: i18n.t(
                        'cms.referral.payout_plan.modal.input.error.plan_name.messages',
                      ),
                    },
                  ],
                })(
                  <Input
                    placeholder={i18n.t('cms.referral.payout_plan.modal.input.name.placeholder')}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12} key="countryId" className="country-box">
              <Form.Item
                label={
                  <span>
                    {i18n.t('cms.referral.payout_plan.modal.input.name.country')}&nbsp;
                    <Tooltip
                      title={i18n.t('cms.referral.payout_plan.modal.input.name.country.tips')}
                    >
                      <Icon
                        style={{ color: 'rgba(0,0,0,.45)', fontSize: '14px' }}
                        type="question-circle-o"
                      />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator(`countryId`, {
                  rules: [
                    {
                      required: true,
                      message: i18n.t('cms.referral.commission_plan.modal.error.blank'),
                    },
                  ],
                  disabled: modalType === EDIT,
                  validateTrigger: 'onBlur',
                })(
                  <AsyncCountrySelector
                    type="id"
                    disabled={modalType === EDIT}
                    queryCountrySlugs={['cn', 'in', 'sg', 'id', 'my', 'th']}
                    onChange={v => this.setState({ selectedCountryId: v })}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={40}>
            <Col span={12} key="bookingCompletedPercent ">
              <Form.Item label={i18n.t('cms.referral.payout_plan.modal.input.name.opps_completed')}>
                {getFieldDecorator(`bookingCompletedPercent`, {
                  rules: [
                    {
                      required: true,
                      message: i18n.t('cms.referral.payout_plan.modal.input.error.messages'),
                    },
                    {
                      validator(_rule, value) {
                        let reg = /\D|[1-9][0-9][1-9]|\d{4,}/; //匹配100 以上的数字
                        if (value && reg.test(value)) {
                          return Promise.reject(
                            i18n.t('cms.referral.payout_plan.modal.input.error.number.messages'),
                          );
                        }
                        const value_ = Number(value);
                        setFieldsValue({
                          bookingPaidPercent: 100 - (value_ || 0),
                          bookingCompletedPercent: typeof value_ === 'number' ? value_ : '',
                        });
                        return Promise.resolve();
                      },
                    },
                  ],
                })(
                  <Input
                    addonAfter="%"
                    placeholder={i18n.t(
                      'cms.referral.payout_plan.modal.input.bookingPaidPercent.placeholder',
                    )}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col className="booking-completed-percent-box" span={12} key="bookingPaidPercent">
              <Form.Item
                label={i18n.t('cms.referral.payout_plan.modal.input.name.landlord_commission')}
              >
                {getFieldDecorator(`bookingPaidPercent`, {
                  initialValue: '100',
                  rules: [],
                })(
                  <Input
                    disabled
                    addonAfter="%"
                    placeholder={i18n.t(
                      'cms.referral.payout_plan.modal.input.bookingCompletedPercent.placeholder',
                    )}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12} key="default">
              <Form.Item label={i18n.t('cms.referral.payout_plan.modal.switch.name')}>
                {getFieldDecorator(`default`, {
                  initialValue: false,
                  valuePropName: 'checked',
                })(<Switch checkedChildren="ON" unCheckedChildren="OFF" />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12} key="tips">
              <p className="switch-tips">{i18n.t('cms.referral.payout_plan.modal.switch.tips')}</p>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({ name: 'modal-add-payout-plan' })(ModalView);
